import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useTopicClusters(
  fromDate: string,
  toDate: string,
  includeMcp?: boolean,
) {
  return useQuery({
    queryKey: ["platformAnalytics", "topicClusters", fromDate, toDate, includeMcp],
    queryFn: () =>
      api.getTopicClusters({
        from_date: fromDate,
        to_date: toDate,
        include_mcp: includeMcp,
      }),
  });
}
